
import TypesProps from './types';

export default {
  name: 'LogoAgrotools',
  props: {
    alt: {
      type: String,
      default: 'Logo Agrotools',
    },
    type: {
      type: String,
      default: 'colorful',
      validator(value: typeof TypesProps[number]) {
        return TypesProps.indexOf(value) !== -1;
      },
    },
    height: String,
    width: String,
  },
};
